<ion-header class="background-lightmimbo">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="onClose()"><ion-icon name="arrow-back-outline" slot="icon-only"> </ion-icon></ion-button>
    </ion-buttons>
    <ion-title>Select Breed</ion-title>
  </ion-toolbar>
  <ion-searchbar class="searchbar" (ionInput)="onFilterChanged(searchBar)" #searchBar
    *ngIf="!isLoading"></ion-searchbar>
</ion-header>
<ion-content color="lightmimbo">
  <div class="ion-text-center ion-padding" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <ion-list *ngIf="!isLoading" class="breedlist">
    <ion-item color="lightmimbo" button="true" *ngFor="let breed of filteredBreedsList" (click)="onSelect(breed)">
      <ion-avatar slot="start">
        <ion-img [src]="breed.imageUrl"></ion-img></ion-avatar>
      <ion-text> {{ breed.name }}</ion-text>
    </ion-item>
  </ion-list>
</ion-content>